/**
 * @ngdoc object
 * @name modules.pos
 * @description
 *
 */
angular.module('festzelt-os.modules.pos', [

]);

require('./routes');

// Controllers
require('./controllers/pos-modal-controller');

// Services
require('./services/pos-service');



// WEBPACK FOOTER //
// ./src/app/modules/pos/pos-module.js